import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';

import { ContentInput } from 'api';
import { ValidatedCheckbox } from 'components';
import { hasVideo } from 'features/content/helpers';

import { BodyTextField, BrandedCheckbox, ImageUpload, TitleTextField } from '../';

const ImageVideoForm: FC = () => {
  const { t } = useTranslation();
  const { values } = useFormikContext<ContentInput>();

  return (
    <Fragment>
      <TitleTextField />
      <ImageUpload />
      <BodyTextField />
      {!hasVideo(values) && (
        <ValidatedCheckbox name="is_shareable" label={t('posting:shareable')} color="primary" />
      )}
      <BrandedCheckbox />
    </Fragment>
  );
};

export default ImageVideoForm;
